import { getIdentifier, getStore } from '~/mst/utils';
import { PERMISSIONS } from '~/mst/models/permissions/types';
import { getFiltersItemsList } from '~/mst/models/abstract/filterable/actions';
import { IUsersModel } from './model';

export default (self: IUsersModel) => {
  return {
    // in time order rather than alphabetical
    get getLastLoginFiltersItemsList() {
      const order = ['last-7-days', 'last-30-days', 'over-90-days', 'never'];
      return getFiltersItemsList(self.filteredModels, 'last-login').sort((a, b) => order.indexOf(a.key) - order.indexOf(b.key));
    },
    get filteredList() {
      const { auth } = getStore(self);
      return self.filteredModels.map((user) => {
        const roles = user.organizationsRoles;
        // an admin's details only for admins
        const isExpandable =
          (!user.isAdmin || Boolean(auth.user?.isAdmin)) &&
          (auth.user?.isSupport || roles.some(({ organizationId }) => auth.user?.hasPermission(PERMISSIONS.ManageUsers, organizationId)));
        return {
          id: getIdentifier(user),
          fullName: user.fullName,
          email: user.email,
          picture: user.picture,
          initials: user.initials,
          createdAt: user.created_at,
          lastLogin: user.last_login_at,
          roles,
          isExpandable
        };
      });
    }
  };
};
